// frontend/src/api/accounting.js
import api from './api';

export const postSalesInvoice = (id) => api.post(`/accounting/post/sales-invoice/${id}`);
export const postPurchaseInvoice = (id) => api.post(`/accounting/post/purchase-invoice/${id}`);
export const postCustomerPayment = (id) => api.post(`/accounting/post/customer-payment/${id}`);
export const postSupplierPayment = (id) => api.post(`/accounting/post/supplier-payment/${id}`);

export const fetchEntries = (params = {}) => api.get('/accounting/entries', { params });
export const fetchEntry = (id) => api.get(`/accounting/entries/${id}`);
export const fetchARSummary = (params = {}) => api.get('/accounting/ar/summary', { params });
export const fetchAPSummary = (params = {}) => api.get('/accounting/ap/summary', { params });
export default api;
